import React, {useContext, useEffect, useRef, useState} from "react";
import LockIcon from "@assets/icon-picto-lock.svg";

import {CartContext} from "@contexts/Cart.jsx"
import { getFormatedPrice } from "@utility/shopify"
import htmlContent from '@assets/dynamic-checkout-buttons.html'


export default ({ className }) => {

  const {loading, cart} = useContext(CartContext);

  const checkoutRef = useRef(null);
  const [hasAcceleratedCheckout, setHasAcceleratedCheckout] = useState(false);

  // Shopify only renders the accelerated checkout buttons from Liquid (cart drawer / cart page), so we find the
  // rendered element and move it into this footer. Moved (not cloned) so Shopify's hydration and shadow root stay intact.
  useEffect(() => {
    const container = checkoutRef.current;
    const accelerated = [...document.querySelectorAll("shopify-accelerated-checkout-cart")]
      .find(el => !container?.contains(el));

    if (!accelerated || !container) return;

    const originalParent = accelerated.parentNode;
    const originalNext = accelerated.nextSibling;

    container.appendChild(accelerated);
    setHasAcceleratedCheckout(true);

    // Put it back where it came from so the cart drawer / cart page still has it
    return () => {
      if (originalParent?.isConnected) originalParent.insertBefore(accelerated, originalNext);
    };
  }, []);

  const price = loading ? <span className="skeleton skeleton--text" style="--skeleton-text-width: 20%"></span> : getFormatedPrice(cart.items_subtotal_price);

  return <div className="v-stack gap-4 sm:gap-6" slot="footer">
        <div className="v-stack gap-1">
          <div className="h-stack gap-4 justify-between">
            <span className="cart-total bold">Total</span>
            <span className="cart-total-price bold">{price}</span>
          </div>
          <p className="text-subdued text-sm">Free shipping, taxes calculated at checkout</p>
        </div>
      <form action="/cart" method="POST" className="buy-buttons buy-buttons--compact">
        <a href="/cart" className="button button--xl button--outline" data-no-instant={true}>
          View Cart
        </a>
        <button type="submit" class="button button--xl" name="checkout" is="custom-button">
          <div>
            <div className="text-with-icon justify-center">
              Checkout
              <LockIcon />
            </div>
          </div>
          <span className="button__loader">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </form>
      <div class="one-step-checkout one-step-checkout--single additional-checkout-buttons" hidden={!hasAcceleratedCheckout}>
        <div ref={checkoutRef}></div>
      </div>
    </div>;
}
